export const ScrollToContainerTop = (ref: any) => {
    if (ref?.current) {
        ref?.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    }
};